import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, isRef as _isRef, createVNode as _createVNode, withCtx as _withCtx, withModifiers as _withModifiers, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "full-width" }

import { computed, ref } from "vue";
import { GroupableTableHeaderProps } from "@/types";
import { useScreen, useVModel } from "@/hooks";
import { Searchbar, SelectInput } from "@/components/common/input";
import { IconButton } from "@/components/common/button";
import { FlexBox } from "@/components/common/display";


/**
 * header inputs for a table that can be grouped and expanded.
 */
const __default__ = {
  name: "GroupableTableHeader",
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    columns: {},
    searchText: {},
    searchLabel: {},
    groupBy: {},
    sortBy: {},
    sortDesc: { type: Boolean },
    inFullscreen: { type: Boolean }
  },
  emits: ["update:searchText", "update:sortBy", "update:sortDesc", "update:groupBy", "toggle-fullscreen"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const { smallWindow } = useScreen();

const collapsed = ref(true);

const searchText = useVModel(props, "searchText");
const sortBy = useVModel(props, "sortBy");
const sortDesc = useVModel(props, "sortDesc");
const groupBy = useVModel(props, "groupBy");

const groupOptions = computed(() =>
  props.columns
    .filter(({ name, groupable }) => name !== "actions" && groupable !== false)
    .map(({ name, label }) => ({ name, label }))
);

const sortOptions = computed(() =>
  props.columns
    .filter(({ name, sortable }) => name !== "actions" && sortable !== false)
    .map(({ name, label }) => ({ name, label }))
);

const displayOptions = computed(() => !smallWindow.value || !collapsed.value);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(FlexBox), {
      "full-width": "",
      align: "center"
    }, {
      default: _withCtx(() => [
        _createVNode(_unref(Searchbar), {
          modelValue: _unref(searchText),
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(searchText) ? (searchText).value = $event : null)),
          label: props.searchLabel
        }, null, 8, ["modelValue", "label"]),
        _createVNode(_unref(IconButton), {
          dense: "",
          icon: props.inFullscreen ? 'fullscreen-exit' : 'fullscreen',
          tooltip: props.inFullscreen ? 'Exit Fullscreen' : 'Enter Fullscreen',
          class: "q-ml-md",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (emit('toggle-fullscreen')))
        }, null, 8, ["icon", "tooltip"])
      ]),
      _: 1
    }),
    _createVNode(_unref(FlexBox), {
      wrap: "",
      align: "center",
      t: "2"
    }, {
      default: _withCtx(() => [
        _createVNode(_unref(SelectInput), {
          modelValue: _unref(groupBy),
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_isRef(groupBy) ? (groupBy).value = $event : null)),
          outlined: "",
          clearable: "",
          dense: "",
          label: "Group By",
          options: groupOptions.value,
          "option-value": "name",
          "option-label": "label",
          class: "q-mr-sm q-mb-sm",
          "option-to-value": "",
          "data-cy": "artifact-table-group-by"
        }, null, 8, ["modelValue", "options"]),
        (displayOptions.value)
          ? (_openBlock(), _createBlock(_unref(SelectInput), {
              key: 0,
              modelValue: _unref(sortBy),
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_isRef(sortBy) ? (sortBy).value = $event : null)),
              outlined: "",
              clearable: "",
              dense: "",
              label: "Sort By",
              options: sortOptions.value,
              "option-value": "name",
              "option-label": "label",
              "option-to-value": "",
              class: "q-mr-sm q-mb-sm",
              "data-cy": "artifact-table-sort-by"
            }, {
              prepend: _withCtx(() => [
                _createElementVNode("div", {
                  onClick: _cache[4] || (_cache[4] = _withModifiers(() => {}, ["stop"]))
                }, [
                  _createVNode(_unref(IconButton), {
                    small: "",
                    tooltip: "Toggle sort direction",
                    icon: _unref(sortDesc) ? 'arrow-down' : 'arrow-up',
                    onClick: _cache[3] || (_cache[3] = ($event: any) => (sortDesc.value = !_unref(sortDesc)))
                  }, null, 8, ["icon"])
                ])
              ]),
              _: 1
            }, 8, ["modelValue", "options"]))
          : _createCommentVNode("", true),
        (displayOptions.value)
          ? _renderSlot(_ctx.$slots, "header-right", { key: 1 })
          : _createCommentVNode("", true),
        (_unref(smallWindow))
          ? (_openBlock(), _createBlock(_unref(IconButton), {
              key: 2,
              tooltip: "Toggle more options",
              class: "q-mb-sm",
              color: "text",
              icon: collapsed.value ? 'down' : 'up',
              onClick: _cache[6] || (_cache[6] = ($event: any) => (collapsed.value = !collapsed.value))
            }, null, 8, ["icon"]))
          : _createCommentVNode("", true)
      ]),
      _: 3
    }),
    _renderSlot(_ctx.$slots, "header-bottom")
  ]))
}
}

})